import { useEffect, useRef } from 'react'
import { Toast } from 'primereact/toast'

// local imports
import logo from 'assets/images/koc-logo.svg'
import useDictionary from 'i18n/use-dictionary'
import RouterConfig from './navigation/RouterConfig'
import ScrollToTop from './ScrollToTop'
import Loader from 'components/ui/Loader'

export default function App() {
  const { dictionaryLoading } = useDictionary()

  const toastRef = useRef<any>(null)
  useEffect(() => {
    ;(window as any).primeToast = toastRef || {}
  }, [])

  return (
    <>
      {dictionaryLoading ? (
        <div className="vh-100 d-flex align-items-center justify-content-center">
          <Loader src={logo} />
        </div>
      ) : (
        <>
          <ScrollToTop>
            <RouterConfig />
          </ScrollToTop>
        </>
      )}

      <Toast ref={toastRef} />
    </>
  )
}
